module.exports = __webpack_public_path__ + "img/草莓.78c244aa.gif";